<template>
    <v-container>
        <v-overlay v-model="overlay" color="white" opacity="1" persistent>
            <v-container style="text-align: center">
                <v-progress-circular :size="50" color="#234a98" indeterminate></v-progress-circular>
                <p class="pt-2" style="font-size: 14px; color: #234a98">
                    {{ $t('common.loading') }}
                </p>
            </v-container>
        </v-overlay>
        <v-card class="mt-4 mb-4">
            <v-layout id="makeMeBlue">
                <v-flex xs6 sm6 md3 class="mt-4 mb-4 ml-4 mr-4">
                    <v-select v-model="client" color="#213A8F" outlined :items="clients" :label="$t('manageSensors.client')"
                        prepend-inner-icon="mdi-account" append-icon="mdi-arrow-down-drop-circle-outline"
                        append-icon-color="#213A8F" :no-data-text="$t('common.noDataAvailable')" />
                </v-flex>
                <v-flex xs6 sm6 md3 class="mt-4 mb-4 ml-4 mr-4">
                    <v-select prepend-inner-icon="mdi-home" v-model="buildingValue" :items="buildings" :label="$t('manageSensors.building')"
                        outlined append-icon="mdi-arrow-down-drop-circle-outline" :no-data-text="$t('common.noDataAvailable')">
                    </v-select>
                </v-flex>
                <v-flex xs6 sm6 md3 class="mt-4 mb-4 ml-4 mr-4">
                    <v-select prepend-inner-icon="mdi-floor-plan" class="ml-2"
                        append-icon="mdi-arrow-down-drop-circle-outline" v-model="floorValue" :items="floors"
                        :label="$t('manageSensors.floor')" outlined :key="floorKey" :no-data-text="$t('common.noDataAvailable')">
                    </v-select>
                </v-flex>
                <v-flex xs6 sm6 md3 class="mt-4 mb-4 ml-4 mr-4">
                    <v-select v-model="areaValue" color="#213A8F" outlined :items="areas" :label="$t('manageSensors.area')"
                        prepend-inner-icon="mdi-texture-box" append-icon="mdi-arrow-down-drop-circle-outline"
                        append-icon-color="#213A8F" :no-data-text="$t('common.noDataAvailable')" />
                </v-flex>
                <v-flex xs6 sm6 md3 class="mt-4 mb-4 ml-4 mr-4">
                    <v-select v-model="sensorValue" prepend-inner-icon="mdi-access-point-network"
                        append-icon="mdi-arrow-down-drop-circle-outline" :items="sensors" :label="$t('manageSensors.sensor')" outlined
                        :key="sensorKey" :no-data-text="$t('common.noDataAvailable')">
                    </v-select>
                </v-flex>
            </v-layout>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="ClearFilter">
                    <span style="color: #213A8F;">{{ $t('manageSensors.clearFilter') }}</span>
                    <v-icon color="#213A8F" left>mdi-close</v-icon>
                </v-btn>
            </v-card-actions>
        </v-card>

        <v-card>

            <v-layout id="makeMeBlue">
                <v-flex xs12 sm12 md12>
                    <v-card-text>
                        <v-data-table v-bind:headers="headers" :items="items" :hide-default-footer="true"
                            disable-pagination class="elevation-1 mt-4" style="overflow-x: auto;" :no-data-text="$t('manageSensors.noDataAvailable')">
                            <template v-slot:item="{ item }">
                                <tr>
                                    <td v-if="item.Gestito == 0"><v-icon color="red">mdi-close-circle-outline</v-icon>
                                    </td>
                                    <td v-if="item.Gestito == 1"><v-icon color="green">mdi-check-circle-outline</v-icon>
                                    </td>
                                    <td>
                                        <v-icon color="#213A8F" @click="openConfirmDialog(item)">mdi-pencil-circle-outline</v-icon>
                                    </td>
                                    <td>
                                        <img class="mt-2 mr-4 align-center" style="width: 50px; text-align:center"
                                            :src="item.DispenserImage" 
                                            @error="handleImageError" />
                                    </td>
                                    <td>{{ item.DeviceName }}</td>
                                    <td>{{ $store.state.company == '1' ? item.BuildingName.replace('Zwetko Headquarter',
            'Airport') : item.BuildingName }}</td>
                                    <td>{{ item.FloorName }}</td>
                                    <td>{{ item.AreaName || '-' }}</td>
                                    <td>
                                        <div v-html="formatTimestamp(item.Timestamp)"></div>
                                    </td>
                                    <td>
                                        <div v-if="item.Gestito == 1" v-html="formatTimestamp(item.Timestamp_Gestione)"></div>
                                        <span v-else style="color: #999;">-</span>
                                    </td>
                                    <td>
                                        <span v-if="item.Gestito == 1">{{ calculateDuration(item.Timestamp, item.Timestamp_Gestione) }}</span>
                                        <span v-else style="color: #999;">-</span>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-flex>
            </v-layout>
        </v-card>

        <!-- Dialog di conferma evasione alert -->
        <v-dialog v-model="confirmDialog" persistent max-width="650">
            <v-card>
                <v-card-title class="headline justify-center" style="color: #213A8F; font-weight: bold;">
                    {{ $t('alerts.confirmResolve') }}
                </v-card-title>
                <v-card-text class="pb-4">
                    <p class="text-center mb-4" style="font-size: 15px; color: #666;">
                        {{ $t('alerts.confirmResolveMessage', { 
                            status: selectedAlert && selectedAlert.Gestito == 0 ? $t('alerts.resolved') : $t('alerts.unresolved') 
                        }) }}
                    </p>
                    
                    <v-divider class="mb-5"></v-divider>
                    
                    <h3 class="text-center mb-4" style="color: #213A8F; font-weight: bold;">{{ $t('alerts.sensorDetails') }}</h3>
                    
                    <v-container v-if="selectedAlert" class="px-4">
                        <v-row class="mb-3">
                            <v-col cols="12" sm="6" class="text-center">
                                <div style="background-color: #f5f7fa; border-radius: 8px; padding: 16px;">
                                    <p style="color: #999; font-size: 12px; margin-bottom: 8px; text-transform: uppercase; font-weight: 600; letter-spacing: 0.5px;">
                                        {{ $t('alerts.sensorName') }}
                                    </p>
                                    <p style="color: #213A8F; font-weight: bold; font-size: 16px; margin: 0;">
                                        {{ selectedAlert.DeviceName || '-' }}
                                    </p>
                                </div>
                            </v-col>
                            <v-col cols="12" sm="6" class="text-center">
                                <div style="background-color: #f5f7fa; border-radius: 8px; padding: 16px;">
                                    <p style="color: #999; font-size: 12px; margin-bottom: 8px; text-transform: uppercase; font-weight: 600; letter-spacing: 0.5px;">
                                        {{ $t('alerts.building') }}
                                    </p>
                                    <p style="color: #213A8F; font-weight: bold; font-size: 16px; margin: 0;">
                                        {{ $store.state.company == '1' ? selectedAlert.BuildingName.replace('Zwetko Headquarter', 'Airport') : selectedAlert.BuildingName || '-' }}
                                    </p>
                                </div>
                            </v-col>
                        </v-row>
                        
                        <v-row class="mb-3">
                            <v-col cols="12" sm="6" class="text-center">
                                <div style="background-color: #f5f7fa; border-radius: 8px; padding: 16px;">
                                    <p style="color: #999; font-size: 12px; margin-bottom: 8px; text-transform: uppercase; font-weight: 600; letter-spacing: 0.5px;">
                                        {{ $t('alerts.floor') }}
                                    </p>
                                    <p style="color: #213A8F; font-weight: bold; font-size: 16px; margin: 0;">
                                        {{ selectedAlert.FloorName || '-' }}
                                    </p>
                                </div>
                            </v-col>
                            <v-col cols="12" sm="6" class="text-center">
                                <div style="background-color: #f5f7fa; border-radius: 8px; padding: 16px;">
                                    <p style="color: #999; font-size: 12px; margin-bottom: 8px; text-transform: uppercase; font-weight: 600; letter-spacing: 0.5px;">
                                        {{ $t('alerts.area') }}
                                    </p>
                                    <p style="color: #213A8F; font-weight: bold; font-size: 16px; margin: 0;">
                                        {{ selectedAlert.AreaName || '-' }}
                                    </p>
                                </div>
                            </v-col>
                        </v-row>
                        
                        <v-row class="mb-2">
                            <v-col cols="12" sm="6" class="text-center">
                                <div style="background-color: #f5f7fa; border-radius: 8px; padding: 16px; min-height: 96px; display: flex; flex-direction: column; justify-content: center;">
                                    <p style="color: #999; font-size: 12px; margin-bottom: 8px; text-transform: uppercase; font-weight: 600; letter-spacing: 0.5px;">
                                        {{ $t('alerts.receivedAt') }}
                                    </p>
                                    <p style="color: #213A8F; font-weight: bold; font-size: 16px; margin: 0;">
                                        {{ formatTimestampInline(selectedAlert.Timestamp) }}
                                    </p>
                                </div>
                            </v-col>
                            <v-col cols="12" sm="6" class="text-center">
                                <div style="background-color: #f5f7fa; border-radius: 8px; padding: 16px; min-height: 96px; display: flex; flex-direction: column; justify-content: center; align-items: center;">
                                    <p style="color: #999; font-size: 12px; margin-bottom: 8px; text-transform: uppercase; font-weight: 600; letter-spacing: 0.5px;">
                                        {{ $t('alerts.currentStatus') }}
                                    </p>
                                    <v-chip :color="selectedAlert.Gestito == 1 ? 'green' : 'red'" text-color="white" small>
                                        {{ selectedAlert.Gestito == 1 ? $t('alerts.resolved') : $t('alerts.unresolved') }}
                                    </v-chip>
                                </div>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions class="px-6 pb-4">
                    <v-spacer></v-spacer>
                    <v-btn text color="#213A8F" @click="confirmDialog = false" large>
                        {{ $t('alerts.cancel') }}
                    </v-btn>
                    <v-btn color="#213A8F" dark @click="confirmResolve" large style="font-weight: bold;">
                        {{ $t('alerts.confirm') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </v-container>
</template>

<script>
import { formatDateTimeDisplay, toBackendDateTimeISO } from '@/utils/dateTimezone';
import axios from "axios";
export default {
    name: 'AlertsView',
    data() {
        return {
            areas: [],
            areaValue: '',
            clients: [],
            client: '',
            buildings: [],
            floors: [],
            sensors: [],
            isFilterActive: false,
            selectedSensor: '',
            sensorKey: 0,
            floorKey: 0,
            buildingKey: 0,
            overlay: false,
            building_name: "YouTissue HQ",
            floor_name: "First",
            daGestire: 5,
            pagination: { 'sortBy': 'name', 'descending': true, rowsPerPage: 25 },
            selected: [],
            items: [],
            sensor_items: [],
            sensorValue: '',
            building_items: [],
            buildingValue: '',
            floor_items: [],
            items_ok: [],
            floorValue: '',
            confirmDialog: false,
            selectedAlert: null,
            headers_it: [
                { text: "", align: "left", value: "Gestito" },
                { text: "Device ID", align: "left", value: "deviceID" },
                { text: "Device", align: "left", value: "deviceName" },
                // { text: "Posizione", align: "left", value: "position" },
                { text: "Distanza", align: "left", value: "distance" },
                { text: "Data e ora", align: "left", value: "timestamp" },
            ],
        }
    },
    computed: {
        headers() {
            return [
                { text: "", align: "center", value: "Gestito", sortable: "false" },
                { text: "", align: "center", value: "", sortable: "false" },
                { text: this.$t('manageSensors.type'), align: "center", value: "Type" },
                { text: this.$t('manageSensors.sensor'), align: "center", value: "DeviceName" },
                { text: this.$t('manageSensors.building'), align: "center", value: "Building" },
                { text: this.$t('manageSensors.floor'), align: "center", value: "Floor" },
                { text: this.$t('manageSensors.area'), align: "center", value: "Area" },
                { text: this.$t('alerts.triggerAt'), align: "center", value: "Timestamp" },
                { text: this.$t('alerts.resolvedAt'), align: "center", value: "Timestamp_Gestione" },
                { text: this.$t('alerts.duration'), align: "center", value: "Duration" },
            ]
        }
    },
    created() {
        this.FilterAlert();
        axios.post(this.$store.state.URL_GET_AVAILABLE_CLIENT)
            .then(res => {
                res.data.forEach(el => {
                    var element = { text: el.CompanyName, value: el.id }
                    this.clients.push(element);

                })
            })
            .catch(() => {
                this.overlay = false;
                this.$router.push({ path: "/" });
            })
        setTimeout(() => this.FilterAlert(), 300000);
    },
    // mounted(){
    //     this.GetData();
    //     setTimeout(() => this.GetData(), 300000);
    // },
    methods: {
        /** Normalizza stringa tipo MySQL "YYYY-MM-DD HH:mm:ss" per parsing in tutti i browser */
        parseAlertTimestamp(ts) {
            if (ts == null) return null;
            if (typeof ts === 'number') return new Date(ts);
            if (ts instanceof Date) return isNaN(ts.getTime()) ? null : ts;
            const str = String(ts).trim();
            if (!str || /^0000-00-00/.test(str)) return null;
            const normalized = /^\d{4}-\d{2}-\d{2} \d/.test(str) && !str.includes('T') ? str.replace(' ', 'T') : str;
            const date = new Date(normalized);
            return isNaN(date.getTime()) ? null : date;
        },
        formatTimestamp(timestamp) {
            if (!timestamp || timestamp === '-' || /^0000-00-00/.test(String(timestamp).trim())) {
                return '-';
            }
            try {
                const date = this.parseAlertTimestamp(timestamp);
                if (!date) return '-';
                const tz = this.$store.state.timezone || 'Europe/Rome';
                const formatted = formatDateTimeDisplay(date, tz);
                if (!formatted) return '-';
                const [datePart, timePart] = formatted.split(' ');
                return `<span style="font-weight: bold; color: #213A8F;">${datePart || ''}</span><br><span style="color: #666; font-size: 0.9em;">${timePart || ''}</span>`;
            } catch (error) {
                console.error('Error formatting timestamp:', error);
                return '-';
            }
        },
        formatTimestampInline(timestamp) {
            if (!timestamp || timestamp === '-' || /^0000-00-00/.test(String(timestamp).trim())) {
                return '-';
            }
            try {
                const date = this.parseAlertTimestamp(timestamp);
                if (!date) return '-';
                const tz = this.$store.state.timezone || 'Europe/Rome';
                const formatted = formatDateTimeDisplay(date, tz);
                return formatted || '-';
            } catch (error) {
                console.error('Error formatting timestamp:', error);
                return '-';
            }
        },
        calculateDuration(startTime, endTime) {
            if (!startTime || !endTime || endTime === '-' || /^0000-00-00/.test(String(endTime).trim())) {
                return '-';
            }
            try {
                const start = this.parseAlertTimestamp(startTime);
                const end = this.parseAlertTimestamp(endTime);
                if (!start || !end) {
                    return '-';
                }
                
                // Calculate difference in milliseconds
                const diff = end - start;
                
                if (diff < 0) {
                    return '-';
                }
                
                // Convert to readable format
                const days = Math.floor(diff / (1000 * 60 * 60 * 24));
                const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
                
                let result = '';
                if (days > 0) result += `${days} d `;
                if (hours > 0) result += `${hours} h `;
                if (minutes > 0 || result === '') result += `${minutes} min`;
                
                return result.trim();
            } catch (error) {
                console.error('Error calculating duration:', error);
                return '-';
            }
        },
        GetData() {
            this.overlay = true;
            axios.post(this.$store.state.URL_ALERTS, {
                "companyId": this.$store.state.company,
            })
                .then(res => {

                    this.items.length = 0;
                    this.items_ok.length = 0;
                    
                    // Processa le immagini per gli alert
                    const processedItems = res.data.map(item => {
                        if (item.DispenserImage) {
                            // Se l'immagine non è già un URL completo o base64, aggiungi il path S3
                            if (!item.DispenserImage.startsWith('http') && !item.DispenserImage.startsWith('data:image')) {
                                // Il backend restituisce già i nomi dei file nel formato corretto per S3
                                // Non fare ulteriori encoding, concatena direttamente
                                item.DispenserImage = this.$store.state.URL_IMAGES_S3 + item.DispenserImage;
                            }
                        }
                        return item;
                    });
                    
                    this.items = processedItems;
                    this.items_ok = processedItems;
                    axios.post(this.$store.state.URL_GET_AVAILABLE_CLIENT)
                        .then(res => {
                            res.data.forEach(el => {
                                var element = { text: el.CompanyName, value: el.id }
                                this.clients.push(element);

                            })
                        })
                        .catch(() => {
                            this.overlay = false;
                            this.$router.push({ path: "/" });
                        })
                    // console.log(this.items)

                    // let buildings = [];
                    // let floors = [];
                    // this.sensor_items.push({ text: "ALL", value: "ALL" });
                    // this.items.map(el => {
                    //     if (!buildings.includes(el.BuildingName)) {

                    //         if (this.$store.state.company == '1') {
                    //             buildings.push(el.BuildingName.replace('Zwetko Headquarter', 'Airport'));
                    //             this.building_items.push({ text: el.BuildingName.replace('Zwetko Headquarter', 'Airport'), value: el.BuildingName.replace('Zwetko Headquarter', 'Airport') });
                    //         }

                    //         else {
                    //             buildings.push(el.BuildingName);
                    //             this.building_items.push({ text: el.BuildingName, value: el.BuildingName });
                    //         }


                    //     }
                    //     if (this.building_items.length == 1)
                    //         this.buildingValue = this.building_items[0].value;
                    //     if (!floors.includes(el.FloorName)) {
                    //         floors.push(el.FloorName);
                    //         this.floor_items.push({ text: el.FloorName, value: el.FloorName })
                    //     }
                    //     if (this.building_items.length == 1)
                    //         this.floorValue = this.floor_items[0].value;
                    //     if (!this.sensor_items.includes(el.DeviceName)) {
                    //         this.sensor_items.push(el.DeviceName);
                    //         this.sensor_items.push({ text: el.DeviceName, value: el.DeviceName })
                    //     }

                    // })
                    // if (this.$store.state.isFilterActive) {
                    //     this.buildingValue = this.$store.state.buildingFiltered;
                    //     this.floorValue = this.$store.state.floorFiltered;
                    //     this.sensorValue = this.$store.state.sensorFiltered;
                    //     this.buildingKey++;
                    //     this.floorKey++;
                    //     this.sensorKey++;
                    // }
                    this.overlay = false;
                })
        },
        MarkAsDone(id_, stato, sensor_id) {
            var now = toBackendDateTimeISO(new Date());
            axios.post(this.$store.state.URL_UPDATE_ALERTS, {
                "id": id_,
                "stato": stato,
                "sensore": sensor_id,
                "time": now
            })
                .then(res => {
                    console.log(res.data);
                    this.FilterAlert();
                })

        },
        ClearFilter() {
            this.client = '';
            this.clients.length = 0;
            this.buildings.length = 0;
            this.buildingValue = '';
            this.floorValue = '';
            this.floors.length = 0;
            this.areaValue = '';
            this.areas.length = 0;
            this.sensors.length = 0;
            this.sensorValue = '';
            this.buildings = [];
            this.floors = [];
            this.areas = [];
            this.sensors = [];
            this.FilterAlert();
        },
        FilterAlert() {
            this.overlay = true;
            axios.post(this.$store.state.URL_ALERTS, {
                "companyId": this.$store.state.company,
                "clientId": this.client,
                "buildingId": this.buildingValue,
                "floorId": this.floorValue,
                "areaId": this.areaValue,
                "sensorId": this.sensorValue
            })
                .then(res => {
                    console.log('🖼️ AlertsView - Raw API response:', res.data);

                    this.items.length = 0;
                    this.items_ok.length = 0;
                    
                    // Processa le immagini per gli alert
                    const processedItems = res.data.map(item => {
                        console.log('🖼️ Processing alert item:', {
                            DeviceName: item.DeviceName,
                            DispenserImage_original: item.DispenserImage,
                            isBase64: item.DispenserImage ? item.DispenserImage.startsWith('data:image') : false,
                            isHTTP: item.DispenserImage ? item.DispenserImage.startsWith('http') : false
                        });
                        
                        if (item.DispenserImage) {
                            // Se l'immagine non è già un URL completo o base64, aggiungi il path S3
                            if (!item.DispenserImage.startsWith('http') && !item.DispenserImage.startsWith('data:image')) {
                                const originalImage = item.DispenserImage;
                                // Il backend restituisce già i nomi dei file nel formato corretto per S3
                                // Non fare ulteriori encoding, concatena direttamente
                                item.DispenserImage = this.$store.state.URL_IMAGES_S3 + item.DispenserImage;
                                console.log('🖼️ Converted S3 path:', {
                                    original: originalImage,
                                    converted: item.DispenserImage,
                                    URL_IMAGES_S3: this.$store.state.URL_IMAGES_S3
                                });
                            }
                        }
                        return item;
                    });
                    
                    this.items = processedItems;
                    this.items_ok = processedItems;
                    console.log('🖼️ Final processed items:', processedItems);
                    this.overlay = false;
                })
        },
        openConfirmDialog(item) {
            this.selectedAlert = item;
            this.confirmDialog = true;
        },
        confirmResolve() {
            if (!this.selectedAlert) {
                return;
            }
            
            const newStatus = this.selectedAlert.Gestito == 0 ? 1 : 0;
            const now = toBackendDateTimeISO(new Date());
            
            axios.post(this.$store.state.URL_UPDATE_ALERTS, {
                "id": this.selectedAlert.idalerts,
                "stato": newStatus,
                "sensore": this.selectedAlert.DeviceID,
                "time": now
            })
                .then(res => {
                    console.log(res.data);
                    this.confirmDialog = false;
                    this.selectedAlert = null;
                    this.FilterAlert();
                })
                .catch(error => {
                    console.error('Errore durante l\'aggiornamento dell\'alert:', error);
                    this.confirmDialog = false;
                    this.selectedAlert = null;
                })
        },
        handleImageError(event) {
            // Log dell'errore per debug
            console.error('❌ Image load error:', {
                src: event.target.src,
                alt: event.target.alt
            });
            // Nascondi l'immagine se non può essere caricata
            event.target.style.display = 'none';
        }
    },
    watch: {
        client(value) {
            if (value != undefined &&
                value != null &&
                value != "" &&
                value != 0
            ) {
                this.areas.length = 0;
                this.areaValue = '';
                this.areas = [];
                this.floors.length = 0;
                this.floorValue = '';
                this.floors = [];
                this.buildings.length = 0;
                this.buildingValue = '';
                this.buildings = [];
                this.sensors.length = 0;
                this.sensorValue = '';
                this.sensors = [];
                var el = { text: "...", value: "" };
                this.buildings.push(el);
                axios.post(this.$store.state.URL_GET_AVAILABLE_BUILDINGS, {
                    companyId: value
                })
                    .then(res => {
                        res.data.forEach(el => {
                            var element = { text: el.BuildingName, value: el.id }
                            this.buildings.push(element);

                        });
                        // Applica automaticamente il filtro
                        this.FilterAlert();
                    })
            }
            else {
                this.areas.length = 0;
                this.areaValue = '';
                this.areas = [];
                this.floors.length = 0;
                this.floorValue = '';
                this.floors = [];
                this.buildings.length = 0;
                this.buildingValue = '';
                this.buildings = [];
                this.sensors.length = 0;
                this.sensorValue = '';
                this.sensors = [];
                // Applica automaticamente il filtro
                this.FilterAlert();
            }
        },
        buildingValue(value) {
            if (value != undefined &&
                value != null &&
                value != "" &&
                value != 0
            ) {
                this.areas.length = 0;
                this.areaValue = '';
                this.areas = [];
                this.floors.length = 0;
                this.floorValue = '';
                this.floors = [];
                this.sensors.length = 0;
                this.sensorValue = '';
                this.sensors = [];
                var el = {text: "..." , value: ""};
                this.floors.push(el);
                axios.post(this.$store.state.URL_GET_AVAILABLE_FLOORS, {
                    buildingId: value
                })
                    .then(res => {
                        res.data.forEach(el => {
                            var element = { text: el.FloorName, value: el.id }
                            this.floors.push(element);
                        });
                        // Applica automaticamente il filtro
                        this.FilterAlert();
                    })
            } else {
                this.areas.length = 0;
                this.areaValue = '';
                this.areas = [];
                this.floors.length = 0;
                this.floorValue = '';
                this.floors = [];
                this.sensors.length = 0;
                this.sensorValue = '';
                this.sensors = [];
                // Applica automaticamente il filtro
                this.FilterAlert();
            }
        },
        floorValue(value) {
            if (value != undefined &&
                value != null &&
                value != "" &&
                value != 0
            ) {
                this.areas.length = 0;
                this.areaValue = '';
                this.areas = [];
                this.sensors.length = 0;
                this.sensorValue = '';
                this.sensors = [];
                var el = {text: "..." , value: ""};
                this.areas.push(el);
                axios.post(this.$store.state.URL_GET_AVAILABLE_AREAS, {
                    floorId: value
                })
                    .then(res => {
                        res.data.forEach(el => {
                            var element = { text: el.AreaName, value: el.id }
                            this.areas.push(element);
                        });
                        // Applica automaticamente il filtro
                        this.FilterAlert();
                    })
            }
            else{
                this.areas.length = 0;
                this.areaValue = '';
                this.areas = [];
                this.sensors.length = 0;
                this.sensorValue = '';
                this.sensors = [];
                // Applica automaticamente il filtro
                this.FilterAlert();
            }

        },
        areaValue(value) {
            if (value != undefined &&
                value != null &&
                value != "" &&
                value != 0
            ) {
                this.sensors.length = 0;
                this.sensorValue = '';
                this.sensors = [];
                axios.post(this.$store.state.URL_GET_SENSORS_COMPANY_BUILDING_FLOOR_AREA, {
                    companyId: this.client,
                    buildingId: this.buildingValue,
                    floorId: this.floorValue,
                    areaId: value
                })
                    .then(res => {
                        res.data.forEach(el => {
                            var element = { text: el.DispenserUnique, value: el.id }
                            this.sensors.push(element);
                        });
                        // Applica automaticamente il filtro
                        this.FilterAlert();
                    })
            }
            else{
                this.sensors.length = 0;
                this.sensorValue = '';
                this.sensors = [];
                // Applica automaticamente il filtro
                this.FilterAlert();
            }
        },
        sensorValue(value) {
            // Applica automaticamente il filtro quando viene selezionato un sensore
            if (value !== undefined && value !== null) {
                this.FilterAlert();
            }
        },

    },
}
</script>
<style>
.theme--light.v-data-table>.v-data-table__wrapper>table>thead>tr>th {
    color: #213A8F;
    font-size: 14px;
    border-right: 1px solid #bfcce4;
    line-height: 3px;
    border-bottom: 1px solid #bfcce4;
    border-top: 1px solid #bfcce4;
    text-align: center !important;
    white-space: nowrap;
    font-weight: bolder;
}

.theme--light.v-data-table>.v-data-table__wrapper>table>thead>tr>th:first-child {
    border: none !important;
}

.theme--light.v-data-table>.v-data-table__wrapper>table>thead>tr>th:last-child {
    border-right: none !important;
}

/* .theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr > th{
        border-bottom: none !important;
    } */

.theme--light.v-data-table>.v-data-table__wrapper>table>tbody>tr>td,
.theme--light.v-data-table>.v-data-table__wrapper>table>tbody>tr>th:not(.v-data-table__mobile-row) {
    border: none !important;
    padding-top: 12px !important;
    padding-bottom: 12px !important;
}

.theme--light.v-data-table>.v-data-table__wrapper>table>tbody>tr>td div {
    line-height: 1.4;
}
</style>